import { atomWithStorage } from "jotai/utils";

export const dealerEndedAuctionSearchTermsAtom = atomWithStorage<string>(
  "dealerEndedAuctionSearchTermsAtom",
  "",
  undefined,
  { getOnInit: true }
);
